import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Loader from '../../components/Loader';
import User from './User';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';

UserManageDialog.propTypes = {
  user: PropTypes.object.isRequired
};

export default function UserManageDialog(props) {
  const { user } = props;

  if (user.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-screen max-w-screen-lg">
      <CloseDialogButton onClick={props.onClose} />
      <div className="px-6 pt-16 pb-6">
        <User
          user={user}
          onClose={props.onClose}
        />
      </div>
    </DialogTemplate>
  );
};
